import { useCallback } from 'react'
import { useMutation } from '@apollo/react-hooks'

import ACCOUNT_CREDIT_CARDS_QUERY from '../../graphql/queries/account-credit-cards.gql'
import SET_CREDITCARD_DEFAULT_MUTATION from '../../graphql/mutations/set-creditcard-default.gql'
import CREDIT_CARD_FRAGMENT from '../../graphql/fragments/credit-cards.gql'
import { useMutateAndLoading } from './use-mutate-and-loading'

const getProductTypeField = productType => ({
  TVOD: 'useForPurchases',
  SVOD: 'useForSubscriptions'
}[productType])

export const updateDefaultCreditCardCache = (proxy, paymentMethodId, productType) => {
  const accountCache = proxy.readQuery({
    query: ACCOUNT_CREDIT_CARDS_QUERY
  })

  const currentCreditcards = accountCache?.account?.creditcards || []
  const productTypeField = getProductTypeField(productType)

  const updatedCreditcards = currentCreditcards.map((card) => {
    if (card[productTypeField]) {
      return {
        ...card,
        [productTypeField]: false
      }
    }

    if (card.id === paymentMethodId) {
      return {
        ...card,
        [productTypeField]: true
      }
    }

    return card
  })

  updatedCreditcards.forEach((creditcard) => {
    proxy.writeFragment({
      id: `Creditcard:${creditcard.id}`,
      fragment: CREDIT_CARD_FRAGMENT,
      data: creditcard
    })
  })
}

export const useSetCreditcardDefaultMutation = () => {
  const [setCreditcardDefaultMutation] = useMutation(SET_CREDITCARD_DEFAULT_MUTATION)
  const setCreditcardDefaultWithLoading = useMutateAndLoading(setCreditcardDefaultMutation)

  return useCallback((paymentMethodId, productType) => (
    setCreditcardDefaultWithLoading('setDefaultCreditcard', {
      variables: {
        id: paymentMethodId,
        type: productType
      },
      update: (proxy, result) => {
        const paymentMethodSet = result?.data?.setCreditcardDefault
        if (!paymentMethodSet) return

        updateDefaultCreditCardCache(proxy, paymentMethodId, productType)
      }
    })
  ), [setCreditcardDefaultWithLoading])
}

export default useSetCreditcardDefaultMutation
